var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgProductGutters(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.172 4.453l1.969-3.187c.14-.188.375-.329.61-.329.234 0 .421.141.562.329l1.968 3.187c.282.516.47 1.078.47 1.64v.095c0 1.687-1.36 3-3 3-1.688 0-3-1.313-3-3v-.094c0-.563.14-1.125.421-1.64zM3.32 4.398a1.119 1.119 0 00-.656.75 1.118 1.118 0 00-.019.495L4.2 14.978l7.749 7.75.066.061c.077.067.162.122.25.164l.023.01c.141.064.297.1.462.1h12.922l1.677-8.38a1.127 1.127 0 00-.433-1.152l-5.99-4.494a1.125 1.125 0 10-1.35 1.8l3.3 2.476h-9.66l-6.75-6.75H10.5a1.125 1.125 0 000-2.25H3.772a1.128 1.128 0 00-.453.085zm21.559 11.165H13.875v5.25h9.953l1.05-5.25zM6.3 13.896l-.864-5.182 6.188 6.188v4.318l-5.324-5.324z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgProductGutters);
export default ForwardRef;
